<template>
  <TopBarIndex :show-annoucement="true" />
  <div class="container pt-5">
    <div class="card mt-5">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <div class="d-flex">
              <img class="mr-2" src="/assets/images/svg/icon/bullhorn.svg" alt="bell">
              <h4 class="text-success">所有公告</h4>
            </div>

            <hr>
          </div>

        </div>

        <!-- 公告清單 start -->
        <table id="table" class="table border rounded border-top-0 p-0" cellspacing="0" width="100%">
          <thead hidden>
          <tr>
            <th width="20"></th>
            <th></th>
          </tr>
          </thead>
          <tbody>


          </tbody>
        </table>

      </div>
    </div>
  </div>

</template>

<script>
/* eslint-disable */
import { GetQueryString } from "../../../components/helpers.js"
import { api } from "../../../apis/main.js"
import TopBarIndex from "../../../components/TopBarIndex.vue"
import SelectComponent from '../../../components/form/SelectComponent.js';
import dlang from '../../system/dlang.json'
//get_system_permission id參考
import { sub_system_index } from '../../system/config.js'
import { interfaceDeclaration } from "@babel/types";
let $ = window.$;
export default {
  name: 'AnnouncementView',
  props: {
  },
  components: {
    TopBarIndex,
    SelectComponent
  },
  data() {
    return {
      notes: [],
      get_total: 1,
      start_from_row: 0,
      rows_per_page: 10,
    }
  },
  async mounted() {
    this.setAnnoucement();
  },
  computed: {
    dt_data() {
      return this.notes.map(e => {

        return [
          '<small className="fas fa-circle"></small>',
          '<h4 class="text-success">系統公告</h4><p className="mb-0" class="text-left text-dark">'+ e.content +'</p>'
        ].map(e => {
          return (e == undefined || e == null) ? '' : e;
        })
      });
    },
    queryStr() {
      let tmp = {
        get_total: this.get_total,
        start_from_row: this.start_from_row,
        rows_per_page: this.rows_per_page,
        is_index: false
      }
      return GetQueryString(tmp);
    },

  },
  watch: {

  },
  methods: {

    setAnnoucement() {
      $('#table').DataTable().destroy();
      let _this = this;
      this.$nextTick(() => {
        let siteTable = $('#table').DataTable({
          language: dlang,
          searching: false,
          lengthChange: false,
          autoWidth: false,
          dom: "<'table-responsive'tr>" +
              "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
          bSort: true,
          columnDefs: [
            { orderable: false, targets: '_all' },
            { className: 'align-top text-center text-danger pt-3 width20', targets: 0, },
          ],
          drawCallback: function () {

          },
          ajax: (data, callback, settings) => {
              api.post('sm3_1_4?' + _this.queryStr).then(res => {
              this.notes = res.data.data;
              let tmp = _this.dt_data;
              callback({
                data: tmp,
                recordsTotal: res.data.total_row,
                recordsFiltered: res.data.total_row,
                draw: data.draw + 1
              });
            })
          }
        });
      });
    },
  },

}
</script>

<style >

</style>
